import * as React from "react";
import {ListBase, ListProps, Record, useDataProvider, useListContext, useRefresh} from "react-admin";
import {Card, Table, Space, Modal, Input, Checkbox} from "antd";
import {BaseFilterDropdown} from "@src/components/Filters/BaseFilterDropdown";
import SkeletonTable, {SkeletonTableColumnsType} from "../../Common/SkeletonTable";
import {LiveTableWrapper} from "@src/components/Common/tableUtils";
import {ModalWidth} from "@src/components/Common/Variables";
import {ExtendedDataProvider} from "@src/types";
import {useNotify} from "ra-core";
import GeneralFilter from "../../ChangeInstances/GeneralFilter";
import {getPipelineColumns} from "@src/components/Pack/Pipelines/utils";
import PackDashboardTabs from "../PackDashboard/PackDashboardTabs";

const resourcePack = "serviceowner_pack";

const formatStateLabel = (state: string): string => {
    return state
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

const PipelineListView = () => {
    const { ids, data, loading, total, perPage, setPage, page, refetch, setFilters, filterValues } = useListContext();
    const dataProvider: ExtendedDataProvider = useDataProvider();
    const notify = useNotify()
    const refresh = useRefresh();

    // Constant state values
    const states = ['OK', 'FAILED', 'SCHEDULED', 'WAITING_FOR_RESPONSE'];
    const stateOptions = states.map(state => ({ id: state, name: formatStateLabel(state) }));

    const retriggerAIProcessor = (service_item_id: number) => {
        const verb_trigger = `retrigger/service_item/${service_item_id}/`
        let inputValue = '';

        Modal.confirm({
            title: 'Service Owner feedback:',
            icon: null,
            width: ModalWidth,
            style: { height: '70vh' },
            content:
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div>This feedback will be given to the AI model as context for the next loop</div>
                    <Input.TextArea rows={8} style={{ flex: 1 }} placeholder="Your comment" onChange={(e) => inputValue = e.target.value}/>
                </div>,
            onOk() {
                let payload = undefined
                if(inputValue !== "")
                    payload = { serviceowner_comment: inputValue }
                dataProvider.createAction(resourcePack, { data: payload, verb: verb_trigger })
                    .then((response: any) => {
                        refetch();
                        refresh();
                        notify('AI Processor is triggered');
                    })
                    .catch((error: any) => notify(JSON.stringify(error.body), 'error'))
            }
        });
    };

    const pipelineColumns = getPipelineColumns(retriggerAIProcessor)
    const tableData: Record[] = []
    ids.forEach(id => {
        tableData.push(data[id])
    });

    return (
        <Card
            bordered={false}
            className="criclebox tablespace mb-24 pack-card"
        >
            {/* Filters Row */}
            <Space orientation="vertical" size={0} style={{ width: '100%' }}>
                <GeneralFilter
                    filterValues={filterValues}
                    setFilterValues={setFilters}
                    teamsResource={"consumer_teams"}
                    applicationsResource={"owner_applications"}
                    serviceItemsResource={"owner_service_items"}
                    servicesResource={"services"}
                    stateFilterEnabled={false}
                    changeTypeFilterEnabled={false}
                    style={{
                        padding: '16px 6px 0px 12px',
                        // backgroundColor: '#fafafa',
                        // borderRadius: '8px',
                        marginBottom: '0px',
                        // width: '100%',
                    }}
                    spaceDirection="horizontal"
                />
                <div style={{ display: 'flex', gap: '16px', padding: '16px 0px 8px 12px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <BaseFilterDropdown
                        // title="Pipeline State"
                        allTitle="All States"
                        placeholder="All States"
                        value={filterValues?.state}
                        onChange={(value) => setFilters({ ...filterValues, state: value }, {})}
                        options={stateOptions}
                    />
                    <Checkbox
                        checked={filterValues?.applied === true}
                        onChange={(e) => setFilters({ ...filterValues, applied: e.target.checked ? true : undefined }, {})}
                    >
                        Show Applied only
                    </Checkbox>
                </div>



            </Space>

            <LiveTableWrapper refetch={refetch}>
                <SkeletonTable loading={loading} columns={pipelineColumns as SkeletonTableColumnsType[]}>
                    <Table
                        rowKey='id'
                        columns={pipelineColumns}
                        pagination={{ total: total, pageSize: perPage, current: page, onChange: page => setPage(page), showSizeChanger: false, className: "pagination-padding" }}
                        dataSource={tableData}
                    />
                </SkeletonTable>
            </LiveTableWrapper>
        </Card>
    )
}

const PipelineList = (props: ListProps) => (
    <>
        <PackDashboardTabs />
        <ListBase sort={{ field: 'id', order: 'DESC' }} perPage={10} filter={{light: true}} {...props}>
            <PipelineListView />
        </ListBase>
    </>
)


export default PipelineList;